<div class="otp-container" style="--gap: {{ncSize == 'small' ? '8px' : (ncSize == 'large' ? '12px' : '10px')}}">
    <input *ngFor="let input of inputArr;let index = index;" class="otp-input" [class.otp-input-simple]="ncSimple"
        [class.otp-input-large]="ncSize == 'large'" [class.otp-input-small]="ncSize == 'small'"
        [class.otp-input-mask]="ncMask" type="text" autocomplete="off" [disabled]="ncDisabled" [readonly]="ncReadonly"
        maxlength="1" (focus)="inputFocus(index)" (blur)="inputBlur(index)" [ngModel]="value ? value[index]: null"
        (ngModelChange)="onInputChange(index, $event)">
</div>